let csrf;

let isCsrfInitialized = false;

export function setCsrf(value) {
  csrf = value;
  isCsrfInitialized = true;
}

export function getCsrf() {
  if (!isCsrfInitialized) {
    throw new Error("The csrf cannot be retrieved before it's initialized");
  }

  return csrf;
}
